import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title, Meta, DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DatabaseOperationService } from '../../../api/database/database-operation.service';
import { DatalistService } from '../../../api/services/datalist.service';
import { FunctionService } from '../../../api/services/function.service';

@Component({
  selector: 'app-notification-form-popup',
  templateUrl: './notification-form-popup.component.html',
  styleUrls: ['./notification-form-popup.component.css']
})
export class NotificationFormPopupComponent implements OnInit {

  SiteNotificationId: string;
  NotificationForm: any;
  submitted: boolean;
  formTitle: string;
  buttonLabel: string;

  constructor(
    // for SEO
    private titleService: Title,
    private metaTagService: Meta,

    public datalistService: DatalistService,
    private databaseOperationService: DatabaseOperationService,
    private matDialog: MatDialog,
    public functionService: FunctionService,
    public sanitizer: DomSanitizer,
    private router: Router,
    private formBuilder: FormBuilder,
    public dialog: MatDialogRef<NotificationFormPopupComponent>,
  ) { }

  ngOnInit(): void {

    this.NotificationForm = this.formBuilder.group({
      Title: ['', Validators.required],
      Link: ['', Validators.required],
      SiteNotificationId: this.SiteNotificationId,
    });
    this.submitted = false;
    this.formTitle = 'Add';
    this.datalistService.loaderActive = true;
    this.buttonLabel = 'Submit';
    if (this.SiteNotificationId) {
      this.formTitle = 'Edit';
      this.buttonLabel = 'Update';
      this.databaseOperationService.getNotificationDetailById(this.SiteNotificationId).subscribe((data: any) => {
        this.NotificationForm.patchValue(data);
        this.datalistService.loaderActive = false;
      })
    } else {
      this.datalistService.loaderActive = false;
    }
  }
  get formControl() { return this.NotificationForm.controls; }
  onSubmit() {
    this.submitted = true;
    if (this.NotificationForm.invalid) {
      this.functionService.showProcessMessage("Provide vaild information", false);
      return;
    }

    this.save();
  }
  save() {
    this.datalistService.loaderActive = true;
    this.databaseOperationService.saveNotification(this.NotificationForm.value).subscribe(data => {
      this.datalistService.loaderActive = false;
      if (data) {
        if (!this.NotificationForm.value.SiteNotificationId) {
          this.functionService.showProcessMessage("New Notification Added Successfully", true);
        } else {
          this.functionService.showProcessMessage("Notification Updated Successfully", true);
        }
        this.dialog.close(true);
      } else {
        this.functionService.showProcessMessage("An Error Occurred", false);
      }
    })
  }

}

